import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';
import { PreviewService } from './preview.service';

@Injectable({ providedIn: 'root' })
export class RecaptchaLoaderService {
  private platformId = inject(PLATFORM_ID);
  private previewService = inject(PreviewService);
  private refCount = 0;

  load(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    // the homepage preview never submits anything, so there is nothing to protect
    if (this.previewService.isPreview) {
      return;
    }
    this.refCount++;
    if (document.querySelector('script[src*="recaptcha/api.js"]')) return;

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${environment.siteKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  unload(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    if (this.refCount === 0) return;
    this.refCount--;
    if (this.refCount > 0) return;

    document.querySelectorAll('script[src*="recaptcha"]').forEach(el => el.remove());
    document.querySelectorAll('.grecaptcha-badge').forEach(el => {
      (el.parentElement ?? el).remove();
    });
    delete (window as any).grecaptcha;
    delete (window as any).___grecaptcha_cfg;
  }
}
